// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","activityInfosContainer":"Header_activityInfosContainer__mTIAT","progressBarContainer":"Header_progressBarContainer__nc71U"};